<template>
	<div>
		<navbar :title="title" />
		<van-form @submit="popupcheck">
			<van-field
				v-model="event_text"
				name="选择事件"
				label="选择事件"
				placeholder="选择选择事件"
				readonly
				@click="popup.event = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择选择事件' }]"
			/>
			<van-field
				v-model="client_text"
				v-if="showClientAndOrder"
				name="关联客户"
				label="关联客户"
				placeholder="选择关联客户"
				readonly
				@click="popup.client = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联客户' }]"
			/>
			<van-field
				v-model="order_text"
				v-if="showClientAndOrder"
				name="关联订单"
				label="关联订单"
				placeholder="选择关联订单"
				readonly
				@click="popup.order = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联订单' }]"
			/>
			<t-multiple-select
				v-model="form.survey_id"
				v-if="form.survey"
				label="关联勘察单"
				placeholder="点击选择勘察单"
				:option="{label:'name',value:'survey_id'}"
				:columns="surveyList.list"
				@onload="onloadsurvey"
				@confirm="checksurvey"
				:isSearch="true"
				:isShowAll="false"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择关联勘察单' }]"
			/>
			<van-field
				v-model="form.dispatch_name"
				name="流程名称"
				label="流程名称"
				placeholder="选择流程名称"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择流程名称' }]"
			/>
			<van-field
				v-model="form.initiate_date"
				name="预计完成日期"
				label="预计完成日期"
				placeholder="选择预计完成日期"
				readonly
				@click="popup.calendar = true"
				:rules="[{ required: true, trigger: 'onBlur', message: '请选择预计完成日期' }]"
			/>
			<van-field
				v-model="form.dispatch_remark"
				rows="3"
				autosize
				label="派单说明"
				type="textarea"
				placeholder="请说明项目地址，联系人，联系方式，现场情况..."
				:rules="[{ required: true, trigger: 'onBlur', message: '派单说明太短,请补充说明！', validator: (val) => val.length >= 10 }]"
			/>
			<van-field name="uploader" label="附件上传">
				<template #input>
					<van-uploader v-model="form.uploader" :max-count="6" accept="all" icon="upgrade" :after-read="onAfterRead"/>
				</template>
			</van-field>

			<div style="margin: 16px;">
				<van-button round block type="info" native-type="submit">提交</van-button>
			</div>
		</van-form>
		<van-tabbar v-model="activeName">
			<van-tabbar-item name="dispatchsearch" icon="search " to="/dispatch/search">查询</van-tabbar-item>
			<van-tabbar-item name="organization" icon="description" to="/dispatch">我组织的</van-tabbar-item>
			<van-tabbar-item name="initiate" icon="logistics" to="/dispatch/initiate">我发起的</van-tabbar-item>
			<van-tabbar-item name="carriedOut" icon="upgrade" to="/dispatch/carriedOut">我执行的</van-tabbar-item>
			<van-tabbar-item name="add" icon="add-o" to="/dispatch/add">新增派单</van-tabbar-item>
		</van-tabbar>

		<van-popup v-model="popup.event" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="eventList.list"
				@onload="onloadEvent"
				@check="checkEvent"
				:loading="eventList.loading"
				:finished="eventList.finished"
				value-key="event_name"
			></popup-select>
		</van-popup>
		<van-calendar v-model="popup.calendar" @confirm="confirmCalendar" />
		<van-popup v-model="popup.client" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="clientList.list"
				@onload="onloadClient"
				@check="checkClient"
				:loading="clientList.loading"
				:finished="clientList.finished"
				value-key="client_name"
			></popup-select>
		</van-popup>
		<van-popup v-model="popup.order" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="orderList.list"
				@onload="onloadOrder"
				@check="checkOrder"
				@input="onloadOrder"
				:loading="orderList.loading"
				:finished="orderList.finished"
				value-key="order_name"
			></popup-select>
		</van-popup>
		<!-- <van-popup v-model="popup.survey" position="right" :style="{ width: '60%', height: '100%'}">
			<popup-select
				v-model="surveyList.list"
				@onload="onloadsurvey"
				@check="checksurvey"
				@input="onloadsurvey"
				:loading="surveyList.loading"
				:finished="surveyList.finished"
				value-key="survey_name"
			></popup-select>
		</van-popup> -->
	</div>
</template>

<script>
import multiple_select  from "@/components/select/multiple-select";
import popupselect from "@/components/select/index";
import navbar from "@/components/navBar/index";
import { getNowFormatDate } from "@/utils/tool";
import { Toast,Dialog } from "vant";
import { post } from "@/api/dispatch";
// import { uploadFile } from "@/api/file";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { compressImage } from "@/utils/imageUtils"; 

export default {
	name: "customer",
	components: {
		navbar,
		"popup-select": popupselect,
		"t-multiple-select": multiple_select,
	},
	data() {
		return {
			title: "新增派单",
			activeName: "add",
			form: {
				event_id: "",
				client_id: "",
				order_id: "",
				survey_id: [],
				initiate_date: "",
				dispatch_remark: "",
				uploader: [],
				survey: false,
			},
			event_text: "",
			client_text: "",
			order_text: "",
			survey_text: "",
			popup: {
				event: false,
				client: false,
				order: false,
				calendar: false,
				survey: false
			},
			eventList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20
			},
			clientList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20
			},
			orderList: {
				loading: false,
				finished: false,
				list: [],
				page: 1,
				limit: 20
			},
			surveyList:{
				// loading: false,
				// finished: false,
				list: [{ survey_id: "1", survey_name: "请选择" }],
				page: 1,
				limit: 20
			},
			perms: "",
			popupjson:{},
			popupdata: "",
			order_type:""
		};
	},
	computed: {
		// 控制是否显示客户和订单字段
		showClientAndOrder() {
			const p = this.$route.query.p;
			// 当 p 为 0 时隐藏客户和订单选择框，但仍需要处理传入的参数
			const isHidden = p === '0' || p === 0;
			return !isHidden;
		}
	},
	methods: {
		async onAfterRead(file) {
			//图片压缩
			if (file.file.type.startsWith('image/')) {
				const compressedFile = await compressImage(file.file);
				// 替换原始文件为压缩后的文件
				file.file = compressedFile;
				// console.log('File after compression:', file.file); // 添加调试信息
			} 
		},
		onSubmit() {
			let formData = new FormData();
			for (let i = 0; i < this.form.uploader.length; i++) {
				formData.append("file", this.form.uploader[i].file);
			}
			formData.append("event_id", this.form.event_id);
			if(this.$route.query.p === '0' || this.$route.query.p === 0){
				formData.append("client_id", this.$route.query.clientId);
				formData.append("order_id", this.$route.query.orderId);
			}else{
				formData.append("client_id", this.form.client_id);
				formData.append("order_id", this.form.order_id);
			}
			formData.append("survey_id", this.form.survey_id);
			formData.append("dispatch_name", this.form.dispatch_name);
			formData.append("initiate_date", this.form.initiate_date);
			formData.append("dispatch_remark", this.form.dispatch_remark);
			formData.append("requestType", "event_initiate");
			formData.append("token", getToken());
			formData.append("popup", JSON.stringify(this.popupjson));

			const config = {
				headers: {
					"Content-Type": "multipart/form-data"
				}
			};
			axios
				.post(this.GLOBAL.httpURL, formData, config)
				.then((res) => { // 使用箭头函数
					if (res.data.code === 200) {
						Toast.success("新增派单成功!");
						setTimeout(() => {
							this.$router.push({
								path: "/dispatch/initiate",
							});
						}, 1000); // 延时1秒
					} else {
						Toast.fail("网路连接错误,请稍后重试!");
					}
				})
				.catch((error) => {
					Toast.fail("请求失败,请稍后重试!");
					console.error(error);
				});
		},
		onloadEvent(search) {
			// 防止重复请求
			if (this.eventList.loading) {
				return;
			}
			// 设置加载状态
			this.eventList.loading = true;
			// 当有搜索条件时，重置分页
			if (search != undefined) {
				this.eventList.page = 1;
			}
			post({
				requestType: "event_list_data",
				page: this.eventList.page,
				limit: this.eventList.limit,
				event_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.eventList.finished = true;
					}
					if (this.eventList.page != 1) {
						this.eventList.list = this.eventList.list.concat(
							res.obj.rows
						);
					} else {
						this.eventList.list = res.obj.rows;
					}

					this.eventList.page += 1;
					this.eventList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.eventList.loading = false;
					this.eventList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		onloadClient(search) {
			// 防止重复请求
			if (this.clientList.loading) {
				return;
			}
			// 设置加载状态
			this.clientList.loading = true;
			// 当有搜索条件时，重置分页
			if (search != undefined) {
				this.clientList.page = 1;
			}
			post({
				requestType: "client_list",
				page: this.clientList.page,
				limit: this.clientList.limit,
				client_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.clientList.finished = true;
					}
					if (this.clientList.page != 1) {
						this.clientList.list = this.clientList.list.concat(
							res.obj.rows
						);
					} else {
						this.clientList.list = res.obj.rows;
					}

					this.clientList.page += 1;
					this.clientList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.clientList.loading = false;
					this.clientList.finished = true;
					return Toast.fail("数据异常");
				});
				console.log("获取客户列表成功");
		},
		onloadOrder(search) {
			// 防止重复请求
			if (this.orderList.loading) {
				return;
			}
			// 设置加载状态
			this.orderList.loading = true;
			// 当有搜索条件时，重置分页
			if (search != undefined) {
				this.orderList.page = 1;
			}
			post({
				requestType: "order_list_data",
				page: this.orderList.page,
				limit: this.orderList.limit,
				client_id: this.form.client_id,
				order_type:this.order_type,
				order_name: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.orderList.finished = true;
					}
					if (this.orderList.page != 1) {
						this.orderList.list = this.orderList.list.concat(
							res.obj.rows
						);
					} else {
						this.orderList.list = res.obj.rows;
					}

					this.orderList.page += 1;
					this.orderList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.orderList.loading = false;
					this.orderList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		onloadsurvey(search) {
			// 防止重复请求
			if (this.surveyList.loading) {
				return;
			}
			// 设置加载状态
			this.surveyList.loading = true;
			// 当有搜索条件时，重置分页
			// console.log(search);
			// if (search != undefined) {
				this.surveyList.page = 1;
			// }
			post({
				requestType: "survey_list_data",
				page: this.surveyList.page,
				limit: this.surveyList.limit,
				client_id: this.form.client_id,
				order_id: this.form.order_id,
				type: 0,
				search: search
			})
				.then(res => {
					if (res.obj.rows.length === 0) {
						this.surveyList.finished = true;
					}
					if (this.surveyList.page != 1) {
						this.surveyList.list = this.surveyList.list.concat(
							res.obj.rows
						);
					} else {
						this.surveyList.list = res.obj.rows;
					}

					// 设置默认选中项
					if (this.surveyList.list.length > 0) {
						const defaultItems = this.surveyList.list.filter(item => item.order_id === this.form.order_id);
						this.form.survey_id = defaultItems.map(item => item.survey_id);
					}
					this.surveyList.page += 1;
					this.surveyList.loading = false;
				})
				.catch(err => {
					console.log(err);
					this.surveyList.loading = false;
					this.surveyList.finished = true;
					return Toast.fail("数据异常");
				});
		},
		checkClient(value) {
			this.popup.client = false;
			this.client_text = value.client_name;
			this.form.client_id = value.client_id;
			this.surveytk();
			this.resetOrderList();
			this.onloadOrder();
		},
		checkOrder(value) {
			this.popup.order = false;
			this.order_text = value.order_name;
			this.form.order_id = value.order_id;
			this.surveytk();
			// 重载勘察单前先重置列表
			this.resetSurveyList();
			//重载勘察单
			this.onloadsurvey();
		},
		checkEvent(value) {
			if(value.event_id != this.form.event_id){
				// 清除客户相关数据
				this.resetClientList();
				this.onloadClient();
				// 重置订单列表
				this.resetOrderList();
			}
			this.popup.event = false;
			this.event_text = value.event_name;
			this.form.event_id = value.event_id;
			this.order_type = value.order_type_list;
			if(value.perms){
			this.perms = JSON.parse(value.perms);
			if(this.perms.popup == 1 && value.popup){
				this.popupdata = JSON.parse(value.popup);
				this.popupcheck(0,'');
			}
			}else{
				this.perms = "";
			}
			this.surveytk();
		},
		// 重置勘察单列表
		resetSurveyList() {
			this.surveyList.page = 1;
			this.surveyList.finished = false;
			this.form.survey_id = [];
		},
		// 重置客户列表
		resetClientList() {
			// 清除客户相关数据
			this.client_text = "";
			this.form.client_id = "";
			this.clientList.list = [];
			this.clientList.page = 1;
			this.clientList.finished = false;
		},
		// 重置订单列表
		resetOrderList() {
			// 清除订单相关数据
			this.order_text = "";
			this.form.order_id = "";
			this.orderList.list = [];
			this.orderList.page = 1;
			this.orderList.finished = false;
		},
		popupcheck(type) {
			if (this.perms && this.perms.popup == 1) {
				var msg = "";
				if (type == 0) {
					msg = this.popupdata.select_popup
				}else{
					//验证附件是否上传
					if (this.perms && this.perms.file == 1 && this.form.uploader.length == 0) {
						Toast.fail("请上传附件！");
						return;
					}
					msg = this.popupdata.submit_popup;
				}
				Dialog.confirm({
					title: '重要提示',
					message:msg,
					confirmButtonText: '确定',
					cancelButtonText: '未确定'

				})
					.then(() => {
					if(type == 0){
						this.popupjson.select_popup = true;
					}else{
						this.popupjson.submit_popup = true;
						this.onSubmit();
					}
					})
					.catch(() => {
						this.$router.push({
							path: "/dispatch/initiate",
						});
					});

			} else {
					//验证附件是否上传
					if (this.perms && this.perms.file == 1 && this.form.uploader.length == 0) {
						Toast.fail("请上传附件！");
						return;
					}
				this.onSubmit();
			}
		},
		surveytk(){
			if(this.perms){
			if(this.perms.survey == 1 && this.form.order_id && this.form.client_id){
				// console.log("满足条件",this.perms);
				this.form.survey = true;
			}else{
				this.form.survey = false;
			}
			}else{
				this.form.survey = false;
			}
		},
		checksurvey(value) {
			// value 是当前选中数据的value的数组
			// value1 是当前选中数据的整个obj集合
			// this.popup.survey = false;
			// this.survey_text = value.survey_name;
			// this.form.survey_id = value.survey_id;
			console.log(value)
			// console.log(value1)
			this.form.survey_id = value;
		},
		confirmCalendar(value) {
			this.form.initiate_date = getNowFormatDate(value);
			this.popup.calendar = false;
		},
		clearForm() {
			for (var key in this.form) {
				if (key == "uploader") {
					this.form[key] = [];
				} else if (key != "type" && key != "requestType") {
					this.form[key] = "";
				}
			}
			this.order_text = "";
			this.client_text = "";
			this.event_text = "";
		}
	}
};
</script>

<style scoped>
.van-icon-photograph:before {
	content: "\F0D2";
}
</style>